import axios from 'axios'
import urlConfig from 'services/urlConfig.js'

const emailApi = {
  url: urlConfig.rideqEmail,
  instance: axios.create({
    baseURL: urlConfig.rideqEmail,
    headers: {}
  }),
  post: (route, body) => emailApi.instance.post(route, body),
  get: (route, body) => emailApi.instance.get(route, body)
}

emailApi.sendOrderVerification = body => {
  return emailApi.post('sendOrderVerification', body)
}

emailApi.sendKlarnaOrderVerification = body => {
  return emailApi.post('sendKlarnaOrderVerification', body)
}

emailApi.newSubscriber = email => {
  return emailApi.post('emailSubscriber', { email })
}

emailApi.clearTestSubscriptions = () => {
  return emailApi.post('clearTestSubscriptions')
}

emailApi.newUser = email => {
  return emailApi.post('emailNewUser', { email })
}

export default emailApi
